import { ReactElement } from 'react';
import PersonIcon from '@mui/icons-material/Person';

import styles from './HistoryTitle.module.scss';

interface IProps {
  patientFullName: string;
}

const HistoryTitle = ({ patientFullName }: IProps): ReactElement => (
  <div className={styles.modalTitle}>
    <span className={styles.titlePatient}>
      <PersonIcon className={styles.titlePatientIcon} />
      <span className={styles.titlePatientName}>{patientFullName}</span>
    </span>
    <span className={styles.titleText}>History</span>
  </div>
);

export default HistoryTitle;
